export const filterFacilitiesList = (facilities) =>
  facilities.filter(({ name, balance }) => {
    if (!balance) {
      return;
    }

    return !['employee', 'director', 'petty'].some((tag) => name.toLowerCase().includes(tag));
  });
